export default "__VITE_ASSET__4a3d7083__"